export function variable(v: string) {
  return v;
}
